import { render, staticRenderFns } from "./LinkSocialImg.vue?vue&type=template&id=763b0960&scoped=true&"
import script from "./LinkSocialImg.vue?vue&type=script&lang=js&"
export * from "./LinkSocialImg.vue?vue&type=script&lang=js&"
import style0 from "./LinkSocialImg.vue?vue&type=style&index=0&id=763b0960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b0960",
  null
  
)

export default component.exports